import React, { useState } from "react";
import "./../Styles/Contact.css";

const SEND_URL =
  process.env.REACT_APP_API_URL ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "/api/send"
    : "https://true-bloom-tutoring.vercel.app/api/send");

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return;

    setError("");
    setSubmitted(false);
    setSubmitting(true);

    const form = event.currentTarget;
    const formData = new FormData(form);

    const payload = {
      parentName: formData.get("parent_name"),
      phone: formData.get("phone"),
      email: formData.get("email"),
      grade: formData.get("grade"),
      subjects: formData.get("subjects"),
      message: formData.get("message") || "",
      honey: formData.get("_honey"),
    };

    try {
      const response = await fetch(SEND_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.error || "Could not send your request.");
      }

      setSubmitted(true);
      form.reset();
    } catch (err) {
      setError(
        err.message || "Could not send your request. Please email truebloomtutoring@gmail.com."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="contact">
      <div className="container contact-layout">
        <div className="contact-intro reveal">
          <p className="eyebrow">Get started</p>
          <h2 className="section-title">Book your free intro call</h2>
          <p className="section-lead">
            Tell us a little about your student. We’ll follow up quickly to talk goals,
            matching, and whether True Bloom is the right fit.
          </p>

          <div className="contact-channels">
            <a className="contact-channel" href="tel:+15875746444">
              <span>Call or text</span>
              <strong>(587) 574-6444</strong>
            </a>
            <a className="contact-channel" href="mailto:truebloomtutoring@gmail.com">
              <span>Email</span>
              <strong>truebloomtutoring@gmail.com</strong>
            </a>
          </div>

          <p className="contact-note">
            Prefer to talk first? Call or text anytime — many parents start with a quick conversation.
          </p>
        </div>

        <form className="contact-form reveal" onSubmit={handleSubmit}>
          <h3>Request a callback</h3>
          <p>Takes about one minute. No commitment required.</p>

          <input type="text" name="_honey" style={{ display: "none" }} tabIndex="-1" autoComplete="off" />

          <div className="form-grid">
            <div className="form-field">
              <label htmlFor="parentName">Your name</label>
              <input id="parentName" name="parent_name" type="text" required placeholder="Alex Parent" />
            </div>
            <div className="form-field">
              <label htmlFor="phone">Phone</label>
              <input id="phone" name="phone" type="tel" required placeholder="(587) 000-0000" />
            </div>
            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input id="email" name="email" type="email" required placeholder="you@email.com" />
            </div>
            <div className="form-field">
              <label htmlFor="grade">Student grade</label>
              <select id="grade" name="grade" required defaultValue="">
                <option value="" disabled>
                  Select grade
                </option>
                <option>Grade 7</option>
                <option>Grade 8</option>
                <option>Grade 9</option>
                <option>Grade 10</option>
                <option>Grade 11</option>
                <option>Grade 12</option>
                <option>Other / University prep</option>
              </select>
            </div>
            <div className="form-field full">
              <label htmlFor="subjects">Subjects needed</label>
              <input
                id="subjects"
                name="subjects"
                type="text"
                required
                placeholder="e.g. Math 30-1, Chemistry, English"
              />
            </div>
            <div className="form-field full">
              <label htmlFor="message">Anything we should know?</label>
              <textarea
                id="message"
                name="message"
                placeholder="Goals, schedule preferences, or challenges your student is facing"
              />
            </div>
          </div>

          <button className="btn btn-primary form-submit" type="submit" disabled={submitting}>
            {submitting ? "Sending…" : "Send My Request"}
          </button>
          {submitted && (
            <p className="form-success">
              Thanks — we received your request and will follow up shortly.
            </p>
          )}
          {error && <p className="form-error">{error}</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;
